
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 55.958 45.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M48.292 45.5H7.667a1.749 1.749 0 01-1.75-1.75v-35A1.749 1.749 0 017.667 7h40.625a1.749 1.749 0 011.75 1.75v35a1.749 1.749 0 01-1.75 1.75zM9.417 42h37.125V10.5H9.417zm21.5-38.5h-5.834a1.75 1.75 0 010-3.5h5.834a1.75 1.75 0 010 3.5z"}}),_c('path',{staticClass:"a",attrs:{"d":"M28 9.416a1.75 1.75 0 01-1.75-1.75V1.833a1.75 1.75 0 013.5 0v5.833A1.75 1.75 0 0128 9.416zm26.208 21.5a1.749 1.749 0 01-1.75-1.75v-5.833a1.75 1.75 0 013.5 0v5.833a1.749 1.749 0 01-1.75 1.75zM26.249 38.5a1.75 1.75 0 01-1.564-2.532L28.668 28H22.75a1.749 1.749 0 01-1.565-2.532l5.25-10.5a1.75 1.75 0 113.13 1.565l-3.983 7.968H31.5a1.75 1.75 0 011.565 2.532l-5.25 10.5a1.747 1.747 0 01-1.566.967z"}}),_c('path',{staticClass:"a",attrs:{"d":"M54.125 28h-5.833a1.75 1.75 0 010-3.5h5.833a1.75 1.75 0 010 3.5zM1.75 30.916A1.75 1.75 0 010 29.166v-5.833a1.75 1.75 0 013.5 0v5.833a1.75 1.75 0 01-1.75 1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M7.667 28H1.833a1.75 1.75 0 010-3.5h5.834a1.75 1.75 0 010 3.5z"}})])
          )
        }
      }
    